import { getRandomColor } from "@/libraries/colors";
import { QUERY_KEYS } from "@/libraries/constant";
import { bulletinService } from "@/services/bulletin";
import type { BulletinsSearchSchema, GetBulletinsResponse } from "@/types";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import compact from "lodash/compact";

export const getBulletinSubscriptionGroupsOptions = () =>
	queryOptions({
		queryKey: [QUERY_KEYS.GET_BULLETIN_SUBSCRIPTION_GROUPS],
		queryFn: () => bulletinService.subscribedGroups(),
		select: (data) =>
			data?.groups?.map((group) => ({
				...group,
				color: getRandomColor(group.name),
			})) ?? [],
	});

export const getBulletinGroupsOptions = () =>
	queryOptions({
		queryKey: [QUERY_KEYS.GET_BULLETIN_GROUPS],
		queryFn: () => bulletinService.groups(),
		select: (data) => ({
			my_groups: data?.my_groups ?? [],
			publics: data?.publics ?? [],
		}),
	});

export const getBulletinsOptions = (
	params?: Pick<BulletinsSearchSchema, "group_id">,
) =>
	infiniteQueryOptions({
		queryKey: compact([QUERY_KEYS.GET_BULLETINS, params]),
		initialPageParam: 1,
		queryFn: ({ pageParam }) =>
			bulletinService.bulletins<GetBulletinsResponse>({
				page: pageParam,
				...params,
			}),
		getNextPageParam: (lastPage) => lastPage?.meta?.next_page,
		select: (data) => data?.pages?.flatMap((page) => page.bulletins) ?? [],
	});

export const getBulletinsMetaOptions = (
	params?: Pick<BulletinsSearchSchema, "group_id">,
) =>
	queryOptions({
		queryKey: compact([QUERY_KEYS.GET_BULLETINS_FLAT, params]),
		queryFn: () =>
			bulletinService.bulletins<GetBulletinsResponse>({
				page: 1,
				...params,
			}),
	});
